module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.64d4cf64.eot";